/* OFFSET BRITAIN - Header Scroll Behavior v53 */

document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.site-header');
  
  if (header) {
    const scrollThreshold = 50;
    
    function handleScroll() {
      if (window.scrollY > scrollThreshold) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
    
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
  }
  
  // Auto-detect white hero pages
  const whiteHeroPages = ['/pages/projects', '/pages/about', '/pages/contact', '/pages/faq', '/pages/modern-slavery'];
  const currentPath = window.location.pathname;
  
  if (whiteHeroPages.some(page => currentPath.includes(page))) {
    document.body.classList.add('white-hero');
  }
  
  // Smoker's Offset addon toggle
  const smokersCheckbox = document.getElementById('smokers-offset-addon');
  if (smokersCheckbox) {
    smokersCheckbox.addEventListener('change', function() {
      const addonSection = this.closest('.plan-addon');
      if (this.checked) {
        addonSection.classList.add('selected');
        sessionStorage.setItem('smokers-addon-selected', this.dataset.variantId);
      } else {
        addonSection.classList.remove('selected');
        sessionStorage.removeItem('smokers-addon-selected');
      }
    });
  }
});

console.log('%c🇬🇧 Offset Britain | Est. 2005', 'color: #0D9548; font-size: 14px; font-weight: bold;');
